import { render, staticRenderFns } from "./LoadingTips.vue?vue&type=template&id=207dcc52&scoped=true&lang=pug&"
import script from "./LoadingTips.vue?vue&type=script&lang=ts&"
export * from "./LoadingTips.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingTips.vue?vue&type=style&index=0&id=207dcc52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207dcc52",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadImage: require('/app/src/components/atoms/LoadImage.vue').default})
